const linkWithTagParam = ( base, tag ) => {
    if (!base || base === "") {
        return "/";
    }
    return `${base}?tag=${tag}`;
}

export default linkWithTagParam;